import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { servicePages } from '../../../lib/schiek-content';

export default function ServicesSection() {
  return (
    <section id="services" aria-labelledby="services-heading" className="bg-[#f4f1ea] py-16 text-slate-950 lg:py-20">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:px-8">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <p className="text-sm font-semibold text-amber-700">Leistungswege</p>
          <h2 id="services-heading" className="mt-3 max-w-xl text-3xl font-semibold leading-tight sm:text-4xl">
            Die Website ist jetzt in echte Einsatzzweige aufgeteilt.
          </h2>
          <p className="mt-4 max-w-xl text-base leading-8 text-slate-700">
            Nicht eine große Allgemeinseite, sondern klar getrennte Wege für Panne, Unfall, Falschparker,
            Fahrzeugtransport und die wichtigsten Zielseiten, die in Berlin gefunden werden sollen.
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            <Link
              to="/leistungen"
              className="inline-flex items-center gap-2 rounded-full bg-slate-950 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
            >
              Alle Leistungen
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
            <Link
              to="/einsatzgebiete"
              className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-950 transition-colors hover:border-amber-300 hover:bg-amber-50"
            >
              Einsatzgebiete
            </Link>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
          {servicePages.map((service, index) => (
            <article
              key={service.slug}
              className="flex h-full flex-col rounded-[1.5rem] border border-slate-300 bg-white p-5 shadow-[0_16px_36px_rgba(15,23,42,0.06)] transition-transform duration-200 hover:-translate-y-1"
            >
              <p className="text-xs font-semibold text-amber-700">0{index + 1}</p>
              <h3 className="mt-3 text-lg font-semibold text-slate-950">{service.shortTitle}</h3>
              <p className="mt-3 flex-1 text-sm leading-7 text-slate-700">{service.summary}</p>
              <Link
                to={`/leistungen/${service.slug}`}
                className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-slate-950 hover:text-amber-700"
              >
                Seite öffnen
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
